import React, { useEffect, useRef } from "react";

export default function LanguagePickerPopover({
    open,
    position,
    languages = [],
    selected,
    onSelect,
    onClose
}) {
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;

        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClose?.();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [open, onClose]);

    if (!open) return null;

    const safeLanguages = languages.length
        ? languages
        : [{ code: "en-US", label: "English (US)" }];

    return (
        <div
            ref={ref}
            style={{
                position: "absolute",
                top: position.top,
                left: position.left,
                zIndex: 9999,
                background: "#ffffff",
                borderRadius: 8,
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                width: 260,
                maxHeight: 320,
                overflow: "hidden",
                border: "1px solid #E2E8F0"
            }}
        >
            <div
                style={{
                    padding: "8px 12px",
                    borderBottom: "1px solid #E2E8F0",
                    fontWeight: 600,
                    fontSize: 14,
                    color: "#1F2933"
                }}
            >
                Select Language
            </div>
            <div
                style={{
                    maxHeight: 260,
                    overflowY: "auto"
                }}
            >
                {safeLanguages.map((lang) => {
                    const isActive = lang.code === selected;
                    return (
                        <button
                            key={lang.code}
                            type="button"
                            onClick={() => onSelect?.(lang)}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                padding: "8px 12px",
                                border: "none",
                                background: isActive ? "#EEF2FF" : "transparent",
                                textAlign: "left",
                                cursor: "pointer"
                            }}
                        >
                            <span style={{ fontSize: 14, fontWeight: 500, color: "#111322" }}>
                                {lang.label || lang.code}
                            </span>
                            <span style={{ fontSize: 12, color: "#6B7280" }}>{lang.code}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

